import { render } from "./event.vue?vue&type=template&id=4814aed0&lang=pug&bindings={\"items\":\"data\"}"
import script from "./event.vue?vue&type=script&lang=js"
export * from "./event.vue?vue&type=script&lang=js"

import "./event.vue?vue&type=style&index=0&lang=sass"
script.render = render

export default script